import * as Yup from 'yup';
import { DateTime } from 'luxon';

import { lighten, darken } from '@mui/material';

import SimpleChip from '../../utils/utilities/SimpleChip';

import EditServiceCategory from '../Services/ServiceCategories/EditServiceCategory';

import Stylists from './Components/Stylists';

const headers = [
  {
    label: 'Name',
    id: 'name'
  },
  {
    label: 'Category',
    id: 'category',
    render: (row) => {
      let bgColor = lighten(row?.label_color || '#000', 0.7);
      let color = darken(row?.label_color || '#000', 0.6);
      return (
        <SimpleChip label={row.category} color={color} bgColor={bgColor} />
      )
    }
  },
  {
    label: 'Default Price',
    currency: true,
    id: 'default_price'
  },
  {
    label: 'Default Duration',
    id: 'default_duration_in_minutes'
  },
  {
    label: "Default ETA",
    id: "default_estimated_time_to_complete"
  },
  {
    label: "Service",
    id: "in_house",
    multi: true,
    values: [{value: true, label: "In House", status: "success"}, {value: false, label: "External", status: "info"}]
  }
];

const filters = [
  {
    id: "scheduled_date",
    type: "date",
    label: "Scheduled Date",
  }
];


const fields = [
  { 
    fieldType: "formField",
    formFieldType: "text",
    name: "name",
    label: "Name",
    type: "text",
    size: {xs: 12, lg: 6},
  },
  { 
    fieldType: "debounceSearchSolo",
    formFieldType: "select",
    select: [],
    name: "category",
    label: "Select Category",
    url: "repairs/repair_categories",
    fieldName: "name",
    // displayField: "full_name",
    FormComponent: <EditServiceCategory dialog={true} st="repair" />,
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "description",
    label: "Description",
    type: "text",
    multiline: true,
    rows: 3,
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Repair Details",
    name: "service_details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "toggle",
    name: "in_house",
    label: "Repair Type",
    options: [{value: true, label: "In House"}, {value: false, label: "External"}],
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "default_duration_in_minutes",
    label: "Default Duration of Repair",
    helperText: "Please enter time in minutes",
    type: "number",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "default_estimated_time_to_complete",
    label: "Default ETA (Turnaround Time from dropoff to completion)",
    helperText: "Please enter time in days",
    type: "number",
    size: {xs: 12, lg: 6}
  },
  {
    fieldType: "divider",
    header: "Pricing",
    name: "pricing",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "default_cost",
    label: "Default Cost",
    type: "number",
    // checkDisplayField: (values) => { return !values?.in_house},
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "formField",
    formFieldType: "text",
    name: "default_price",
    label: "Default Retail Price",
    type: "number",
    size: {xs: 12, lg: 6},
  },
  // {
  //   fieldType: "formField",
  //   formFieldType: "switch",
  //   name: "charge_for_new_wig",
  //   label: "Charge for New Wig",
  //   type: "checkbox",
  //   size: {xs: 12, lg: 12},
  // },
  {
    fieldType: "divider",
    header: "Setup Repair Specialists",
    name: "assign_specialists",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <Stylists />,
    name: "specialists",
    size: {xs: 12, lg: 12},
  },
]

const initialValues = {
  name: '',
  category: '',
  default_cost: '',
  default_price: '',
  default_duration_in_minutes: '',
  default_estimated_time_to_complete: '',
  charge_for_new_wig: false,
  in_house: true
}

const additionalState = {
  active_stylists: []
}

const schema = Yup.object().shape({
  name: Yup.string().required('Name is Required'),
  category: Yup.string().when('in_house', {
    is: true,
    then: (schema) => schema.required('Category is required'),
    otherwise: (schema) => schema.notRequired()
  }),
  default_cost: Yup.string(),
  default_price: Yup.string(),
  default_duration_in_minutes: Yup.string(),
  default_estimated_time_to_complete: Yup.string(),
  charge_for_new_wig: Yup.boolean(),
  in_house: Yup.boolean(),  
  charge_for_new_wig: Yup.boolean()
});


export { fields, initialValues, schema, additionalState, headers, filters 
  // parseData,
 };